import { render, staticRenderFns } from "./TextMystery.vue?vue&type=template&id=50e07ae7&scoped=true&"
import script from "./TextMystery.vue?vue&type=script&lang=js&"
export * from "./TextMystery.vue?vue&type=script&lang=js&"
import style0 from "./TextMystery.vue?vue&type=style&index=0&id=50e07ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e07ae7",
  null
  
)

export default component.exports